import { z, ZodType } from 'zod';
import { zObject } from '../../util/zod';

import { WidgetsName, WidgetType } from './common';

export const widgetEmailsImapContentSchema = z.object({
    emailsLimit: z.boolean().optional(),
    emailsLimitValue: z.number().optional(),
    emailsPromptStatus: z.string().optional(),
});

export type WidgetEmailsImapContent = z.infer<typeof widgetEmailsImapContentSchema>;

export type WidgetEmailsImapType = {
    name: WidgetsName.EmailsImap;
    uniqid: string;
    content: WidgetEmailsImapContent;
};
export const widgetEmailsImapTypeSchema: ZodType<WidgetType<WidgetEmailsImapContent>> = zObject<WidgetEmailsImapType>({
    name: z.literal(WidgetsName.EmailsImap),
    uniqid: z.string(),
    content: widgetEmailsImapContentSchema,
}) satisfies ZodType<WidgetType<WidgetEmailsImapContent>>;
